var {
  setCookie,
  getCookie,
  updateUtmCookie,
  updateCtaCookie,
  readAttributionQuery,
  mergeAttributionQuery,
  UTM_COOKIE,
  REGISTERED_COOKIE,
  CTA_COOKIE,
  CTA_PAGE_PARAM,
  CTA_BLOCK_PARAM,
  INTERNAL_UTM_SOURCES,
  FIRST_TOUCH_ONLY_SOURCES,
} = require("./utm-tracking");

var {
  parseUtmParams,
  buildAttributionProps,
  registerPostHogAttribution,
} = require("./posthog-attribution");

var {
  INTERCOM_LANG_OVERRIDES,
  toIntercomLanguage,
} = require("./intercom-language");

var limits = require("../constants/limits.json");
var pricing = require("../constants/pricing.json");
var chat = require("../constants/chat.json");
var productionLocations = require("../constants/production_locations.json");
var isoCountries = require("../constants/iso_countries.json");

module.exports = {
  setCookie,
  getCookie,
  updateUtmCookie,
  updateCtaCookie,
  readAttributionQuery,
  mergeAttributionQuery,
  UTM_COOKIE,
  REGISTERED_COOKIE,
  CTA_COOKIE,
  CTA_PAGE_PARAM,
  CTA_BLOCK_PARAM,
  INTERNAL_UTM_SOURCES,
  FIRST_TOUCH_ONLY_SOURCES,
  parseUtmParams,
  buildAttributionProps,
  registerPostHogAttribution,
  INTERCOM_LANG_OVERRIDES,
  toIntercomLanguage,
  MULTI_EPISODES_MAX_FILES: limits.multiEpisodesMaxFiles,
  DUDE_CHAT_MAX_FILES_PER_THREAD: limits.dudeChatMaxFilesPerThread,
  DUDE_CHAT_MAX_FILE_SIZE_MB: limits.dudeChatMaxFileSizeMb,
  // "Write it myself" on an empty scene of a script AI wrote: the form stops at these and the
  // backend refuses past them.
  AI_SCENE_HAND_MAX_BLOCKS: limits.aiSceneHandMaxBlocks,
  AI_SCENE_HAND_BLOCK_MAX_CHARS: limits.aiSceneHandBlockMaxChars,
  AI_SCENE_HAND_CUE_MAX_CHARS: limits.aiSceneHandCueMaxChars,
  // A budget's own unit label typed by hand; the backend refuses a longer one.
  BUDGET_CUSTOM_UNIT_MAX_CHARS: limits.budgetCustomUnitMaxChars,
  // Prices are sold by the app, quoted by the landing and charged by the backend, so the
  // table lives in constants/pricing.json and every runtime reads it from there. Keys are
  // the monthly tier in dollars; values are what that tier bills per month when paid yearly.
  MONTHLY_TIERS_USD: pricing.monthlyTiersUsd,
  ANNUAL_MONTHLY_USD: pricing.annualMonthlyUsd,
  // The Dude server writes this token at the head of a turn's source attribution and the
  // chat renders the label for it, translated. It lives here because the two apps must
  // agree on it exactly and neither owns it: a rename on one side alone silently stops the
  // attribution being recognised, and the line then reads as ordinary prose.
  DUDE_SOURCES_MARKER: chat.dudeSourcesMarker,
  // Where a production can be based. The SAME list the backend validates against
  // (common/shared_locations.py), because the dropdown a producer picks from and the value the
  // API accepts must be one vocabulary: a country the picker offers and the serializer refuses
  // is a dead entry nobody can explain, and the reverse is a country nobody can reach.
  PRODUCTION_COUNTRIES: productionLocations.countries,
  // Every country that EXISTS, which is what the pickers offer since the owner lifted the
  // 48-country restriction. Generated from the same ISO table the backend validates against, so
  // the two halves of the old rule still hold: nothing offered here can be refused by the
  // serializer, and nothing the serializer accepts is unreachable in the UI.
  ISO_COUNTRIES: isoCountries.countries,
  DEFAULT_PRODUCTION_COUNTRY: productionLocations.defaultCountry,
};
